import { Navigate } from "react-router-dom";

export default function LogoutPage() {
  return <Navigate to="/auth/login" />;
}
